import FormBlock from 'components/formComponents/Layout/FormBlock';
import CompanyBlock from './CompanyBlock';
import { useAppSelector } from '../../../../../hooks';
import { useMemo } from 'react';
import WorksiteBlock from './WorksiteBlock';

type Props = {
  isCheckingExistingBankruptcyIncident?: boolean;
};

const PartyRegardingApplication = ({
  isCheckingExistingBankruptcyIncident = false,
}: Props) => {
  const { partyRegardingApplication, pageTexts } = useAppSelector(
    (state) => state.partyApplication
  );
  const texts = useMemo(() => {
    return pageTexts?.partyRegardingApplicationSection;
  }, [pageTexts]);

  const checkingText = useMemo(() => {
    return (
      pageTexts?.submitSection?.existingBankruptcyCheckingInfo ??
      'Kontrollerar om det redan finns ett konkursärende...'
    );
  }, [pageTexts]);

  return (
    <FormBlock
      title={texts?.partyHeadline}
      isLoading={isCheckingExistingBankruptcyIncident}
      loadingText={checkingText}
    >
      <CompanyBlock texts={texts} />
      {partyRegardingApplication && <WorksiteBlock texts={texts} />}
    </FormBlock>
  );
};

export default PartyRegardingApplication;
